export const ageMethod = "age nearest";
export const gateway = "https://qat-sterling-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/sterling";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzdGVybGluZyIsIm5hbWUiOiJzdGVybGluZyIsImlhdCI6MTc4MDU4MzcxNywiZXhwIjoxOTM4MzcxNzE3fQ.WDbJCyjiRlasg-U7QBcT8h9g7rvqDp2YXRBVzWsSG_c";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-sterling.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_sterling",
			brands: [
				"qat-sterling.link-nonprod.wawanesalife.com",
			],
			broker: "sterling",
			broker_formatted_name: "Sterling Brokers",
			email: "info@sterlingbrokers.com",
			environment: "qat",
			environment_id: "qat",
			g4: "G-BKLFX8DNNL",
			layout: "bohemia",
			logoPosition: "menu",
			map1: [
				"48-209 Wicksteed Avenue",
				"Toronto",
				"ON",
				"M4G 0B1",
			],
			map2: [
				"Suite 200 84 Chain Lake Drive",
				"Halifax",
				"NS",
				"B3S 1A2",
			],
			map3: [
				"Suite 1501 1111 West Georgia St.",
				"Vancouver",
				"BC",
				"V6E 4M3",
			],
			map4: [
				"Unit 110 4919-59 Street",
				"Red Deer",
				"AB",
				"T4P 1M8",
			],
			menuPhone: "button",
			phone: "1-888-213-5557",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.iubenda.com/privacy-policy/90666380/full-legal",
			tagline: "A world-class client experience",
			themeSwitcher: "hide",
			website: "https://www.sterlingbrokers.com/",
			scope: "sterling#branding#qat-sterling.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-sterling.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_sterling",
			brands: [
				"qat-sterling.link-nonprod.wawanesalife.com",
			],
			broker: "sterling",
			broker_formatted_name: "Sterling Brokers",
			email: "info@sterlingbrokers.com",
			environment: "qat",
			environment_id: "qat",
			g4: "G-BKLFX8DNNL",
			layout: "bohemia",
			logoPosition: "menu",
			map1: [
				"48-209 Wicksteed Avenue",
				"Toronto",
				"ON",
				"M4G 0B1",
			],
			map2: [
				"Suite 200 84 Chain Lake Drive",
				"Halifax",
				"NS",
				"B3S 1A2",
			],
			map3: [
				"Suite 1501 1111 West Georgia St.",
				"Vancouver",
				"BC",
				"V6E 4M3",
			],
			map4: [
				"Unit 110 4919-59 Street",
				"Red Deer",
				"AB",
				"T4P 1M8",
			],
			menuPhone: "button",
			phone: "1-888-213-5557",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.iubenda.com/privacy-policy/90666380/full-legal",
			tagline: "A world-class client experience",
			themeSwitcher: "hide",
			website: "https://www.sterlingbrokers.com/",
			scope: "sterling#branding#qat-sterling.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-sterling.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:35:17 GMT+0000 (Coordinated Universal Time)
